// HOTSPOT TOOLTIPS

/*! tooltips.js
    v0.1 (c) Mircea Piturca
    MIT License
*/
(function Tooltips(SD){
  'use strict';
  
  var support = getSupport();
  var instances = nodeList('[data-tooltips-config]');

  instances.map(function(instance){
    var config = Object.freeze(getConfig(instance));

    var publicAPI = {
      tooltips: function() { return getTooltips(config) },
      tooltip: getTooltip,
      select: select,
      deselect: deselect,
      config: config,
      init: init
    }

    if (!SD[config.sectionId]) init(config);    
    SD[config.sectionId] = publicAPI;
    
    return publicAPI;
  })


  // ******************************

  function init(config) {
    var tooltips = getTooltips(config);
    var triggers = pluck(tooltips, 'trigger');

    triggers.map(function(element) {
      element.addEventListener('click', function triggerClick() {
        tooltipClick(tooltips, element.value);
      });
    });
  }

  function getConfig(instance) {
    return JSON.parse(instance.innerHTML);
  }

  function getTooltips(config) {
    return config.blocksId.map(getTooltip);
  }

  function getTooltip(id) {
    var host = document.getElementById('tooltip-' + id);

    return {
      id: id,
      trigger: host.querySelector('[data-tooltip-trigger]'),
      overlay: host.querySelector('[data-tooltip-overlay]'),
      markup: host.querySelector('[data-tooltip-markup]'),
      get collapsed() { return isCollapsed(this) }
    }
  }

  function tooltipClick(tooltips, id) {
    var isSelected = partial(idMatch, id);
    tooltips.filter(isSelected).map(toggle);
    tooltips.filter(not(isSelected)).filter(not(isCollapsed)).map(collapse);
  }
  
  function toggle(tooltip) {
    tooltip.collapsed ? expand(tooltip) : collapse(tooltip);
  }

  function expand(tooltip) {
    tooltip.overlay.innerHTML = tooltip.markup.textContent;
    tooltip.overlay.style.setProperty('--end-h', height(tooltip));
    tooltip.overlay.style.setProperty('--start-h', '0px');
    tooltip.trigger.setAttribute('aria-expanded', true);

     tooltip.overlay.addEventListener('animationend', function animationEndFn() {
      animationReset(tooltip.overlay, animationEndFn);
    });

    return tooltip;
  }

  function collapse(tooltip) {
    tooltip.overlay.style.setProperty('--start-h',  height(tooltip));
    tooltip.overlay.style.setProperty('--end-h', '0px');
    tooltip.trigger.setAttribute('aria-expanded', false);
    
    if (!support.customProperties) tooltip.overlay.innerHTML = '';

    tooltip.overlay.addEventListener('animationend', function animationEndFn() {
      animationReset(tooltip.overlay, animationEndFn);
      tooltip.overlay.innerHTML = '';
    });

    return tooltip;
  }

  function animationReset(element, callback) {
    element.removeAttribute('style');
    element.removeEventListener('animationend', callback);
  }

  function idMatch(id, tooltip) {
    return tooltip.id === id;
  }

  function isCollapsed(tooltip) {
    return attr('aria-expanded', tooltip.trigger) === 'false';
  }

  function height(tooltip) {
    return px(tooltip.overlay.offsetHeight.toString());
  }

  function px(n) {
    return n + 'px';
  }

  /* DOM */
  function attr(str, element) {
    return element.getAttribute(str);
  }

  function nodeList(str, root) {
    if (!root) root = document;
    var nodeList = root.querySelectorAll(str);
    return Array.prototype.slice.call(nodeList);
  }

  /* Fn */
  function not(predicate) {
    return function negated() {
      return !predicate.apply(undefined, arguments);
    };
  }

  function pluck(array, key) {
    return array.map(function(obj) {
      return obj[key];
    });
  }

  function partial(fn) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 1);
    return function() {
      return fn.apply(this, args.concat(slice.call(arguments, 0)));
    };
  }

  /* Support */
  function getSupport() {
    return {
      customProperties: window.CSS && CSS.supports('color', 'var(--primary)'),
    }
  }

  /* Theme editor */
  function select(blockId) {
    return expand(getTooltip(blockId));
  }

  function deselect(blockId) {
    return collapse(getTooltip(blockId));
  }
  
})(window.SectionsDesign = window.SectionsDesign || {});

// Active TAB 

$(document).ready(function () {
  jQuery("#footer-block--menu h5.font-heading").click(function () {
    $(this).toggleClass("tab_active");
  });
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }
  $(".abz-rich-text .abz-button-group a").click(function() {
    $(".abz-rich-text .abz-button-group  a").removeClass("active");
    $(this).addClass("active");
  });
});

// ---------
function togglePopup() {
  $(".content").toggle();
}

// Flickity slider

//   var elem = document.querySelector('.main-carousel');
// var flkty = new Flickity( elem, {
//   // options
//   cellAlign: 'left',
//   contain: true
// });

// // element argument can be a selector string
// //   for an individual element
// var flkty = new Flickity( '.main-carousel', {
//   // options
// });


// slick slider
$('.abz_slick').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
});

// Function to add item to cart using AJAX and trigger ARMADA:CART:ADD event
function abzAddItemToCart(variantId, quantity) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: quantity
      }]
    })
  })
  .then(response => response.json())
  .then(data => {
    // Prepare and dispatch the ARMADA:CART:ADD event
    const event = new CustomEvent("ARMADA:CART:ADD", {
      detail: {
        response: data,
        quantity: quantity
      }
    });
    document.dispatchEvent(event);
  })
  .catch(error => {
    console.error('Error adding item to cart:', error);
  });
}

// Variant click atc
customElements.define('variant-click-atc', class VariantClickAtc extends HTMLElement {
  constructor() {
    super();
    if (this.classList.contains('product-available-false')) return;
    this.addEventListener('click', this.onClick);
  }

  onClick(e) {
    e.preventDefault();
    const variantId = this.getAttribute('data-variant-id');
    abzAddItemToCart(variantId, 1)
    // Add your "add to cart" logic here
  }
});


// collection slideshow slick

$('.Abz_sldier_otd').slick({
  dots: false,
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 6,
responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
   {
    breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


// // Abz Collection slider

// $('.Abz_main_collection_grid_slider').slick({
//   dots: false,
//   infinite: true,
//   slidesToShow: 6,
//   slidesToScroll: 6,
// responsive: [
//     {
//       breakpoint: 1025,
//       settings: {
//         slidesToShow: 5,
//         slidesToScroll: 5,
//       }
//     },
//     {
//       breakpoint: 769,
//       settings: {
//         slidesToShow: 4,
//         slidesToScroll: 4
//       }
//     },
//    {
//     breakpoint: 600,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });



// slick slider
$('.abz_image-with-text-about-slider').slick({
  infinite: false,
  dots:true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 5000,

});


$('.abz-image-scroll-slider').slick({
  infinite: false,
  dots:false,
  slidesToShow: 1,
  draggable:true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,

});
// TEST
document.addEventListener("DOMContentLoaded", function() {
  const sections = document.querySelectorAll(".abz_image-text-scroll");

  if (sections.length > 1) {
    const parentDiv = document.createElement("div");
    parentDiv.classList.add("parent-image-with-text");

    sections[0].parentNode.insertBefore(parentDiv, sections[0]);

    sections.forEach(section => {
      parentDiv.appendChild(section);
    });
  }
});


// TEST2
// $(document).ready(function() {
//   let scrollTimeout;
//   let isSectionFixed = false;  // Flag to track if the section is fixed

//   // Initialize the Slick slider for vertical scrolling
//   $('.parent-image-with-text').slick({
//     vertical: true,            // Enable vertical scrolling
//     slidesToShow: 1,           // Show 1 slide at a time
//     slidesToScroll: 1,         // Scroll 1 slide at a time
//     infinite: false,           // Disable infinite scrolling to control the end of the slider
//     autoplay: false,           // Disable autoplay
//     verticalSwiping: true,     // Enable vertical swiping
//     arrows: false,             // Hide arrows for navigation
//     speed: 1000,               // Speed of the slide transition
//     pauseOnHover: false,       // No pause on hover
//     draggable: false,          // Disable dragging for consistency
//     touchMove: false,          // Disable touch dragging
//   });

//   // Function to check if the section is in the viewport
//   function isSectionInViewport($section) {
//     var sectionOffset = $section.offset().top;
//     var sectionHeight = $section.outerHeight();
//     var windowHeight = $(window).height();
//     var windowScrollTop = $(window).scrollTop();

//     // Check if the section is in the center of the screen
//     return (
//       sectionOffset + sectionHeight / 2 >= windowScrollTop &&
//       sectionOffset + sectionHeight / 2 <= windowScrollTop + windowHeight
//     );
//   }

//   // Function to toggle fixed position based on slider and visibility
//   function toggleFixedPosition() {
//     var $section = $('.parent-image-with-text');
//     var currentSlide = $section.slick('slickCurrentSlide');
//     var totalSlides = $section.slick('getSlick').slideCount;

//     // Add fixed class when the section is in the viewport and it's not the last slide
//     if (isSectionInViewport($section)) {
//       if (!isSectionFixed && currentSlide !== totalSlides - 1) {
//         $section.addClass('fixed-section');
//         isSectionFixed = true;
//       }
//     } else {
//       // Remove the fixed class when the section is out of the viewport
//       if (isSectionFixed) {
//         $section.removeClass('fixed-section');
//         isSectionFixed = false;
//       }
//     }

//     // Remove the fixed class when the last slide is reached
//     if (currentSlide === totalSlides - 1 && isSectionFixed) {
//       $section.removeClass('fixed-section');
//       isSectionFixed = false;
//     }
//   }

//   // Handle the mouse wheel event for scrolling
//   $(document).on('wheel', function(e) {
//     var $section = $('.parent-image-with-text');

//     // Only allow scrolling if the section is in the center of the viewport
//     if (isSectionInViewport($section)) {
//       e.preventDefault(); // Prevent default page scroll

//       // Throttle the scroll event to prevent rapid scrolling
//       clearTimeout(scrollTimeout);
//       scrollTimeout = setTimeout(function() {
//         if (e.originalEvent.deltaY > 0) {
//           // Scroll down: Move to the next slide
//           $section.slick('slickNext');
//         } else {
//           // Scroll up: Move to the previous slide
//           $section.slick('slickPrev');
//         }
//       }, 150); // Adjust the throttle time (150ms) for smooth scrolling
//     }
//   });

//   // Optionally, listen for scroll events to dynamically toggle the fixed position
//   $(window).on('scroll', function() {
//     toggleFixedPosition();
//   });

//   // Initial call to check if the section should be fixed on page load
//   toggleFixedPosition();

//   // Listen for the slide change event to handle the fixed state dynamically
//   $('.parent-image-with-text').on('afterChange', function(event, slick, currentSlide) {
//     toggleFixedPosition();  // Update the fixed position after each slide change
//   });
// });



